export function SET_WELLS_SELECTED(state, wells) {
    state.wellsSelected = wells;
}

export function SET_WELL_SELECTED(state, well) {
  state.wellSelected = well;
}